import { createAction } from 'redux-actions';

import { Actions } from '../constants';

export const realtimeConnectionUpdated = createAction(
  Actions.REALTIME_CONNECTION_UPDATED,
);
